export default __webpack_public_path__ + "static/media/Vectorschedule.ab468d3d.svg";